<template>
  <a-layout-content>
    <h2>{{this.system.name}} Set Off 圣水拍卖场</h2>
    <user />
    <chart />
    <div class="control" v-if="user.is_admin||this.system.control">
    <admin v-if="user.is_admin" />
    <player v-else />
    </div>
    <h4 v-else>由于赛事设置，当前系统处于关闭状态</h4>
  </a-layout-content>
</template>
<script>
import user from '../components/user'
import player from '../components/player'
import admin from '../components/admin'
import chart from '../components/chart'

export default {
  components: {
    user,
    player,
    admin,
    chart
  },
  data () {
    return {
      user: [],
      system: []
    }
  },
  mounted () {
    this.$http
      .get('https://auction-api.joyland.top/user')
      .then(res => {
        if (!res.data || res.data.code === 401) {
          this.$message.info('请检查登录状态')
          this.$router.push('/login')
        } else {
          this.user = res.data
        }
      })
    this.$http
      .get('https://auction-api.joyland.top/system')
      .then(res => {
        this.system = res.data
      })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    }
  }
}
</script>
